import React from "react";
import MainPageHeaderDesktop from "./MainPageHeaderDesktop";
import MainPageHeaderMobile from "./MainPageHeaderMobile";
import { showMobile } from "helpers/adaptation";

export interface MainPageHeaderProps {
  style?: React.CSSProperties | undefined;
  isPricingButtonHidden?: boolean;
  isReloadLogo?: boolean;
  type?: "default" | "main";
  showGameMenu?: boolean;
  title?: string;
  onLogin?: () => void;
}

const MainPageHeader = (props: MainPageHeaderProps) => {
  return (
    <>
      {!showMobile && <MainPageHeaderDesktop {...props} />}
      {showMobile && <MainPageHeaderMobile {...props} onLogin={() => console.log("1231235")} />}
    </>
  );
};

export default MainPageHeader;
